export const REQUIRED_INFORMATION_MESSAGE = "Information in this field is required.";
export const REQUIRED_SERVICE_PROVIDED = "Please select at least one of the following: Alarm installed (any), DHH requested, Pre-existing Alarm Tested and Working, Battery Replaced, Escape Plan Made or Fire Safety Checklist Completed"
export const VALIDE_MAIL_MESSAGE = "Please enter a valid Email";
export const VALIDE_PHONE_MESSAGE = "Please enter a valid 10-digit phone number ###-###-####";
export const VALID_ADDRESS_MESSAGE = "Please enter a valid Address";
export const REVIEW_FIELDS_MARKED_RED = "Please review the fields marked in red on your form.";
export const ERROR_OCCURRED_MESSAGE = "An error occurred, please try again!";
export const ERROR_PEOPLE_SERVED = "Please enter the total number of people served. This field may not be left blank.";
export const ALARMS_WORKING_EXCEED_PRE_EXISTING_ALARMS = "Pre-exisiting alarms tested and working exceeds the number of pre-existing alarms.";
export const YOUTH_SHOULD_NOT_BE_EQUAL_PEOPLE_SERVED = "Youth should not be greater or equal to People Served ";
export const SUM_YOU_THAN_SENIORS_NOT_GREATER_THAN = "The sum of Youth and Seniors should not be greater than People Served"
export const INDIVIDUALS_DISABILITIES = "The sum of Individuals with Disabilities, Access, or Functional Needs should not be greater than People Served "
export const MILITARY_SHOULD_NOT_EXCEED_PEOPLESERVED = "The number of veterans or military members should not exceed the number of People Served";


// Google Constants
export const GOOGLE_STREET_NUMBER_KEY = "street_number";
export const GOOGLE_ROUTE_KEY = "route";
export const GOOGLE_CITY_KEY = "locality";
export const GOOGLE_CITY_KEY_2 = "sublocality";
export const GOOGLE_CITY_KEY_3 = "neighborhood";
export const GOOGLE_CITY_KEY_4 = "administrative_area_level_3";
export const GOOGLE_POSTAL_CODE_KEY = "postal_code";
export const GOOGLE_STATE_CODE_NAME_KEY = "administrative_area_level_1";
export const GOOGLE_COUNTY_CODE_NAME_KEY = "administrative_area_level_2";

export const NO_RECORD_FOUND = "No Matches were found! - Invalid Address";
export const INVALID_ADD_NO_STREET = "Invalid Address: not street level";

// HFC Constants
export const HFC_IN_HOME_VISIT = "HFC In-Home Visit";
export const REMOTE_HFC_SERVICE_DELIVERY = "Remote HFC Service Delivery";
export const PILOT_PROGRAM = "Pilot Program";

export const SERVICE_ACKNOWLEDGMENT_FORM = "Service Acknowledgment Form";
export const PARTNER_DIRECT_SERVICE_ACKNOWLEDGMENT_FORM = "Partner Direct Service Acknowledgment Form";

export const MESSAGE_CLOSE_WINDOW = "Are you sure you want to close this record? Any data entered will not be saved.";

export const ADDRESS_VERIFIED = "Address Verified";
export const VERIFY_ADDRESS = "Verify Address";

export const YES = "Yes";
export const NO = "No";
export const INVALID = "INVALID";

export const BUTTON_COLOR_IS_SUCCESS = "button is-success";
export const BUTTON_COLOR_IS_DANGER_LIGHT = "button is-danger is-light";

export const INVALID_ENTRY = "This is an invalid entry. Please enter the correct code, or change your selection in the Service Type Prompt";
export const INVALID_ENTRY_TIMEOUT_1 = "You have been blocked for 20 seconds after ";
export const INVALID_ENTRY_TIMEOUT_2 = " invalid entries";

export const PILOT_CODE = {
  WILDFIRE: "Wildfire",
  SAFEGIVE: "SAFEGIVE"
};

export function getCalendarInformationMessage(october1st2014) {
  var dateOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  let msg = "Date can not be prior to " +
    october1st2014.toLocaleDateString("en-US", dateOptions);
  return msg; // output "Date can not be prior to Wednesday, October 1, 2014"
}